import { Cart } from "src/types/storefront/Cart";

export default function getCartCurrency(cart: Cart): string {
  const currency =
    cart.cost.subtotalAmount.currencyCode === "USD"
      ? "$"
      : cart.cost.subtotalAmount.currencyCode;
  return currency;
}
